export enum NotificationTypeIds {
  CERTIFICATE_ISSUED = 'CERTIFICATE_ISSUED',
  COURSE_POST_COMMENT = 'COURSE_POST_COMMENT',
  COMMUNITIES_NEW_POST_FOLLOWERS = 'COMMUNITIES_NEW_POST_FOLLOWERS',
  COMMUNITIES_NEW_EVENT_CREATED = 'COMMUNITIES_NEW_EVENT_CREATED',
  COMMUNITIES_POST_GO_LIVE = 'COMMUNITIES_POST_GO_LIVE',
  COMMUNITIES_POST_LIKE = 'COMMUNITIES_POST_LIKE',
}

export enum SourceApp {
  COURSES = 'COURSES',
  CERTIFICATES = 'CERTIFICATES',
  COMMUNITIES = 'COMMUNITIES',
}

export interface NotificationWebProps {
  profileCardIsOpen: boolean
  appLauncherIsOpen: boolean
  notificationListIsOpen: boolean
  position: string
}

export interface NotificationItemProps {
  notification: INotification
}

export interface NotificationListProps {
  markAllRead: () => void
  notificationVisibility: 'all' | 'unread'
  loadMoreNotifications: () => void
}

export interface INotification {
  _id: string
  notificationType: string
  body: string
  redirectionUrl: string
  isRead: boolean
  avatarData: {
    avatarUrl?: string
    badgeUrl?: string
    name?: string
  }
  relativeTime?: string
  createdAt: string
  type?: string
  sourceApp?: SourceApp
  metaData?: {
    commentId?: string
  }
}

export interface NotificationFilters {
  isRead?: boolean
  previousId?: string
  limit?: number
  pageSort?: 'ascending' | 'descending'
}
